import { WebSocketClient } from 'util/webSocketClient';
import { notificationMgr } from 'te-components';

import {
  sessionInfo,
  logout,
  realtimeMsg,
  updateDoNotTextFlag,
  updateUnreadThreads,
  fetchUnclaimedChats,
  fetchJobChatLiveAgentDetails,
} from 'redux/actions';
import { getWebSocketId } from 'util/Api';
import { AriStatus, realTimeEvents } from 'appConstants';
import config from 'config';

let realTime = null;

const getTokenCallback = async () => {
  const { ticketId } = await getWebSocketId();
  return ticketId;
};

const AriDataTypes = [AriStatus.AriDisabled, AriStatus.AriEnabled];
const agentEvents = [realTimeEvents.AGENT_JOINED, realTimeEvents.AGENT_LEFT];

const callActionsOnEventsChange = ({ store, msgData }) => {
  if (msgData.event === realTimeEvents.CANDIDATE_JOINED) {
    store.dispatch(
      fetchUnclaimedChats({
        filters: [
          {
            fieldName: 'assignedUserName',
            type: 'NotExists',
            value: true,
          },
        ],
      }),
    );
  }

  if (agentEvents.includes(msgData.event)) {
    store.dispatch(fetchJobChatLiveAgentDetails({}));
  }
};

const showNotification = (store, message) => {
  const {
    user: { userName },
  } = store.getState();

  if (message.type === 0 && userName === message.userName) {
    /* Only show an HTML notification + update unread count if it's an */
    /* inbound message for the */
    /* current user (so managers don't get notifications for all their */
    /* subordinates'/Ari's activity if they are setup to get it that way) */

    notificationMgr.showNotification(
      message.messageText,
      `${message.candidateName} (TextRecruit)`,
      message.id,
    );
  }
};

const callUpdateMessageActions = ({ store, msgData }) => {
  store.dispatch(updateDoNotTextFlag(msgData.message));
  store.dispatch(realtimeMsg(msgData));
  showNotification(store, msgData.message);
};

const messageExist = ({ message, thread }) => {
  if (message && thread) {
    const hasText = Boolean(message.messageText);
    const ariData = AriDataTypes.includes(message.dataType);
    const hasMedia = Boolean(message.mediaUrl);
    return hasText || ariData || hasMedia;
  }
  return false;
};

const getIsLoggedInUser = ({ data, loggedInUserId }) => {
  const userId = data.thread ? data.thread.userId : '';

  return loggedInUserId === userId;
};

const isThreadInAccessibleInbox = ({ store, msgData }) => {
  const { inboxAccessListWithThreads } = store.getState().thread;
  if (!inboxAccessListWithThreads || !msgData.thread) return false;

  const { thread } = msgData;

  return inboxAccessListWithThreads.some(
    (inbox) =>
      (inbox.accountType && inbox.accountType === 'TEAM') ||
      (inbox.userId && thread.userId && inbox.userId === thread.userId) ||
      (inbox.userName && thread.userName && inbox.userName === thread.userName),
  );
};

const handleUnreadThreads = ({ store, msgData }) => {
  const { id, hasLicense } = store.getState().user;
  const isLoggedInUser = getIsLoggedInUser({ data: msgData, loggedInUserId: id });
  const isAccessibleInbox = isThreadInAccessibleInbox({ store, msgData });

  if (isLoggedInUser || !hasLicense || isAccessibleInbox) {
    store.dispatch(updateUnreadThreads(msgData));
  }
};

export const realTimeMiddleware = (store) => (next) => (action) => {
  // We need session token for realtime-server authentication;
  // hence waiting until token-info API returns a successful response.
  if (sessionInfo.fulfilled.match(action)) {
    realTime = new WebSocketClient(config.realTimeUrl);

    const onMessageCallback = (msgData) => {
      if (msgData.event !== 'backgroundProcess') {
        if (messageExist(msgData)) {
          callUpdateMessageActions({ store, msgData });
        }
        handleUnreadThreads({ store, msgData });
        callActionsOnEventsChange({ store, msgData });
      }
    };

    realTime.connect(getTokenCallback, null, onMessageCallback);
  }
  if (realTime && logout.fulfilled.match(action)) {
    realTime.close(realTime.NORMAL_CLOSE, 'session ended.');
  }
  return next(action);
};
